module.exports = __webpack_public_path__ + "img/patanjali-icon.c2d80a2d.png";